import React, { useState, useEffect, useContext } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { IoReorderThreeOutline } from "react-icons/io5";
import pure from "../resource/pureprakrti.png";
import { AuthContext } from "../AuthContext";

export const Navbar = () => {
  const authContext = useContext(AuthContext);
  const user = authContext?.user;
  const userName = user?.userName;
  const logout = authContext?.logout;
  const navigate = useNavigate();
  const location = useLocation();
  const currentPath = location.pathname;

  const [isMobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [isModalOpen, setModalOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  const toggleModal = () => setModalOpen(!isModalOpen);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 0);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <div
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-200 ease-in-out 
      ${scrolled ? "bg-green-950/90 backdrop-blur-sm text-white " : "bg-transparent text-white "}`}
    >
      <div className="flex items-center justify-between max-w-[1240px] mx-auto px-4 py-2.5">
        {/* Logo */}
        <Link to="/" className="flex items-center space-x-2 md:space-x-4">
          <img src={pure} alt="Pure Prakrti" className="h-9 md:h-16 w-auto" />
          <span className="text-xl md:text-2xl font-bold text-white">Pure Prakruti</span>
        </Link>

        {/* Centered Nav Links */}
        <div
          className={`hidden md:flex flex-1 justify-center items-center space-x-4 lg:space-x-6 text-lg font-semibold transition 
          ${scrolled ? "text-white" : "text-white"}`}
        >
          <Link
            to="/"
            className={`hover:text-green-500 transition ${currentPath === "/"
              ? "text-green-500 underline underline-offset-8"
              : ""
              }`}
          >
            Home
          </Link>
          <Link
            to="/carbonfootprint"
            className={`hover:text-green-500 transition ${currentPath === "/carbonfootprint"
              ? "text-green-500 underline underline-offset-8"
              : ""
              }`}
          >
            Carbon Footprints
          </Link>

          {user && (
            <Link
              to="/UserDashBoard"
              className={`hover:text-green-500 transition ${currentPath === "/UserDashBoard"
                ? "text-green-500 underline underline-offset-8"
                : ""
                }`}
            >
              Dashboard
            </Link>
          )}

          <Link
            to="/contactUs"
            className={`px-5 py-2.5 rounded-full text-lg font-semibold transition 
    ${currentPath === "/contactUs"
                ? "bg-green-600 text-white "
                : "bg-green-600 text-white hover:bg-green-700"
              }`}
          >
            Contact Us
          </Link>
        </div>

        {/* Right Side: Login/User */}
        <div
          className={`hidden md:flex items-center gap-4 ${scrolled ? "text-gray-800" : "text-gray-800"
            }`}
        >
          {user ? (
            <div className="cursor-pointer" onClick={toggleModal}>
              <img
                src="https://www.w3schools.com/w3images/avatar2.png"
                alt="User"
                className="h-12 w-12 md:h-14 md:h-14 rounded-full"
              />
            </div>
          ) : (
            <>
              <button
                className={`px-5 py-2 rounded-lg border font-semibold transition 
                  ${scrolled
                    ? "bg-green-600 text-white border-green-600 hover:bg-green-700"
                    : "bg-white text-green-600 border-green-600 hover:bg-gray-100"
                  }`}
                onClick={() => navigate("/login")}
              >
                Log In
              </button>
              <button
                className={`px-5 py-2 rounded-lg border font-semibold transition
                  ${scrolled
                    ? "bg-white text-green-600 border-green-600 hover:bg-gray-100"
                    : "bg-green-600 text-white border-green-600 hover:bg-green-700"
                  }`}
                onClick={() => navigate("/signup")}
              >
                Sign Up
              </button>
            </>
          )}
        </div>

        {/* Mobile Menu Button */}
        <button
          className="md:hidden text-inherit p-2 hover:bg-white/10 rounded-lg transition-colors"
          onClick={() => setMobileMenuOpen(!isMobileMenuOpen)}
        >
          <IoReorderThreeOutline size={30} />
        </button>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && (
        <div className="md:hidden bg-green-900 text-white flex flex-col items-center py-4 space-y-4">
          <Link to="/" onClick={() => setMobileMenuOpen(false)}>
            Home
          </Link>
          <Link to="/carbonfootprint" onClick={() => setMobileMenuOpen(false)}>
            Carbon Footprints
          </Link>
          {user && (
            <Link to="/UserDashBoard" onClick={() => setMobileMenuOpen(false)}>
              Dashboard
            </Link>
          )}
          <Link to="/contactUs" onClick={() => setMobileMenuOpen(false)}>
            Contact Us
          </Link>
          {user ? (
            <div className="cursor-pointer" onClick={toggleModal}>
              <img
                src="https://www.w3schools.com/w3images/avatar2.png"
                alt="User"
                className="h-10 w-10 rounded-full"
              />
            </div>
          ) : (
            <div className="flex flex-col space-y-2 w-full px-6">
              <button
                className="w-full bg-green-600 text-white py-2 rounded-lg font-semibold hover:bg-green-700 transition"
                onClick={() => {
                  setMobileMenuOpen(false);
                  navigate("/login");
                }}
              >
                Log In
              </button>
              <button
                className="w-full bg-white text-green-600 border border-green-600 py-2 rounded-lg font-semibold hover:bg-gray-100 transition"
                onClick={() => {
                  setMobileMenuOpen(false);
                  navigate("/signup");
                }}
              >
                Sign Up
              </button>
            </div>
          )}
        </div>
      )}

      {/* Modal Popup for User Info & Logout */}
      {isModalOpen && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
          <div className="bg-white rounded-lg p-6 w-[90%] max-w-sm text-center shadow-lg text-black">
            <h2 className="text-xl font-semibold mb-2">User Details</h2>
            <p className="text-gray-700 font-medium">Name: {userName}</p>

            <button
              onClick={() => {
                logout();
                toggleModal();
                navigate("/login");
              }}
              className="mt-6 bg-red-600 text-white px-4 py-2 rounded hover:bg-red-700 transition"
            >
              Logout
            </button>

            <button
              onClick={toggleModal}
              className="mt-3 block w-full text-gray-500 text-sm hover:underline"
            >
              Close
            </button>
          </div>
        </div>
      )}
    </div>
  );
};
